<template>
  <div class="cf-flex cf-flex--column cf-flex--gap-16 cf-padding-bottom-16">
    <span class="cf-icon cf-icon--brand-primary cf-icon--large far fa-heart-broken" />

    <h2 class="cf-title cf-title--2">
      Unavailable Favorite
    </h2>

    <p class="cf-subtitle cf-subtitle--2 cf-subtitle--heavy">
      The favorite item you've selected is not currently available for your selected location or order mode.
    </p>

    <p class="cf-subtitle cf-subtitle--2">
      To find out which of your favorites are currently available, please browse our menu.
    </p>

    <button
      class="cf-button cf-button--primary cf-button--lg cf-button--fill"
      type="button"
      @click="browseMenuClickHandler"
    >
      Browse Menu
    </button>

    <button
      class="cf-button cf-button--secondary cf-button--lg cf-button--fill"
      type="button"
      @click="closeModalHandler"
    >
      Nevermind
    </button>
  </div>
</template>


<script>
  export default {
    name: 'UnavailableFavoriteItem',

    methods: {
      browseMenuClickHandler() {
        const routerPayload = {
          name: 'orderMenu',
          params: {
            merchantId: this.$route.params.merchantId
          }
        };

        this.$router.push(routerPayload);

        this.closeModalHandler();
      },

      closeModalHandler() {
        this.$closeModal('unavailableFavoriteItemModal');
      }
    }
  };
</script>
